import enJSON from './en.json'

export const en = enJSON
